import { Controller } from "@hotwired/stimulus"
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

// Fix pour les icônes Leaflet
import icon from 'leaflet/dist/images/marker-icon.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'

export default class extends Controller {
    static values = {
        latitude: Number,
        longitude: Number,
        markers: Array
    }

    connect() {
        this.initializeMap()
        this.setupMarkerIcons()
        this.addMainMarker()
    }

    initializeMap() {
        this.map = L.map(this.element).setView(
            [this.latitudeValue || 48.05742, this.longitudeValue || 1.301833],
            15
        )

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© OpenStreetMap contributors'
        }).addTo(this.map)
    }

    setupMarkerIcons() {
        let DefaultIcon = L.icon({
            iconUrl: icon,
            shadowUrl: iconShadow,
            iconSize: [25,41],
            iconAnchor: [12,41]
        })
        L.Marker.prototype.options.icon = DefaultIcon
    }

    addMainMarker() {
        L.marker([this.latitudeValue || 48.05742, this.longitudeValue || 1.301833])
            .addTo(this.map)
            .bindPopup('BVA Centre Services - 19 Rte de Blois, 28200 La Chapelle-du-Noyer')
            .openPopup()
    }

    // Actions pour interagir avec la carte
    centerMap(event) {
        const { lat, lng } = event.params
        this.map.setView([lat, lng], 13)
    }

    addMarker(event) {
        const { lat, lng, title } = event.params
        L.marker([lat, lng])
            .addTo(this.map)
            .bindPopup(title)
    }
}